import { GroupLead } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getGroupLeads: (
  fetchContext: FetchContext,
  groupId: number,
  accessToken?: string,
) => Promise<GroupLead[]> = (fetchContext, groupId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/groups/${groupId}/leads`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<GroupLead[]>(fetchContext.errorStore, response, 'get group leads'));
